import { ShipmentInterface } from 'features/ShipmentDetails'
import moment from 'moment'

import { CustomsType } from '../CustomsType'
import { IQuoteRequest } from '../fromMobx'
import { BuyersConsolidationQuoteServicesJSON } from '../QuoteRequest/BuyersConsolidationQuoteServicesJSON'
import { toInsuranceQR } from '../QuoteRequestInsurance'
import { CarbonOffsetStrategy } from '../QuoteServices'
import { IQuoteSheet } from '../QuoteSheet/QuoteSheetModel'

export function fromQuoteSheet(sheet: IQuoteSheet): IQuoteRequest {
  const { request } = sheet
  const quoteRequest: IQuoteRequest = {
    type: request.type,
    modes: request.modes,
    origin: request.journey.origin,
    destination: request.journey.destination,
    cargo: request.cargo,
    cargoStackable: request.services?.isStackable as boolean,
    cargoReadyAt: request.cargoReadyAt ? new Date(request.cargoReadyAt) : null,
    customs:
      request.services?.customsSelected || (!!request.services?.customsIssuance && !!request.services.customsBondType),
    hsCodesCount: request.services?.hsCodesCount as number,
    insuranceEnabled: !!(request.services?.insurances && (request.services?.insurances.length as number) > 0),
    insurance: toInsuranceQR(request.services?.insurances ?? []),
    specialEquipment: request.services?.specialEquipment as boolean,
    dangerousGoods: request.services?.dangerousGoods as boolean,
    dangerousGoodsAdditionalDetails: request.services?.dangerousGoodsAdditionalDetails,
    goodsValue: request.goodsValue,
    customsIssuance: request.services?.customsIssuance as boolean,
    customsBondType: request.services?.customsBondType || '',
    vgm: request.services?.vgm,
    // "as unknown as BuyersConsolidationQuoteServicesJSON" to keep betterer happy without the need of refactor
    // This will be fixed with the non mobx version
    buyersConsolidation: null as unknown as BuyersConsolidationQuoteServicesJSON,
    incoTerm: request.incoTerm,
    bookingParty: request.bookingParty,
    isBookingPartyAgent: request.isBookingPartyAgent,
    carbonOffsetService: request.services?.carbonOffset,
  }
  return quoteRequest
}

export function fromShipment(shipment: ShipmentInterface): IQuoteRequest {
  const modes = [shipment.mode]
  const cargoReadyAt = moment().add(2, 'day').toDate()
  const insuranceEnabled = shipment.insurance && shipment.insurance.length > 0
  const insurance = toInsuranceQR(shipment.insurance)
  const customs = !!(shipment.originCustomsType || shipment.destinationCustomsType)
  const offsetStrategy =
    (shipment.quoteOption?.carbonOffsetQuote?.lineItems?.length as number) > 0
      ? CarbonOffsetStrategy.All
      : CarbonOffsetStrategy.None

  const quoteRequest: IQuoteRequest = {
    ...shipment,
    cargo: shipment.cargo,
    customs,
    insuranceEnabled,
    insurance,
    cargoReadyAt,
    modes,
    customsIssuance: shipment.customsIssuance,
    goodsValue: shipment.goodsValue,
    customsBondType: shipment.customsBondType,
    vgm: shipment.vgm,
    incoTerm: shipment.quoteOption?.incoTerm,
    bookingParty: shipment.quoteOption?.bookingParty,
    carbonOffsetService: {
      offsetStrategy,
    },
    isBookingPartyAgent: shipment.quoteOption?.isBookingPartyAgent,
  } as IQuoteRequest
  return quoteRequest
}

export const customsTypesToJSON = (customs: boolean): CustomsType[] => {
  const customsTypes: CustomsType[] = []
  if (customs) {
    customsTypes.push('standard', 'fiscal', 't1', 't1_only')
  }
  return customsTypes
}
